export default __webpack_public_path__ + "static/share_game_ideas-c29bed534e39ffdcf1d045ac4a3b3dfa.webp";